import React from "react";
import { PRODUCT_NAME } from "../../data/siteConfig";
import { specRows } from "../../data/content";
export function UnitSection() {
  return <section id="unit" aria-labelledby="unit-title" className="on-light scroll-mt-20 bg-ice" data-id="element-272" data-mp="2aw7smo4v1zat">
      <div className="container-x grid gap-10 py-14 sm:py-20 lg:grid-cols-12 lg:gap-16 lg:py-28" data-id="element-273" data-mp="2on32a2n6okfg">
        <div className="lg:col-span-5" data-id="element-274" data-mp="2jpjp76282dp3">
          <p className="eyebrow" data-id="element-275" data-mp="1vyxfzbghendi">The unit</p>
          <h2 id="unit-title" className="mt-4 font-display text-[clamp(1.9rem,8vw,3.6rem)] font-extrabold leading-[0.98] text-navy lg:text-[clamp(2rem,5vw,3.6rem)]" data-id="element-276" data-mp="1vzpeau1gqz7h">
            {PRODUCT_NAME}
          </h2>
          <p className="mt-5 max-w-[32rem] text-[16px] leading-[1.7] text-body sm:mt-6 sm:text-[17px]" data-id="element-277" data-mp="20ya4s1qwy4iq">
            An original, done-for-you beginner floor-hockey unit: 12 structured lessons you can teach in sequence and adapt around your own classes.
          </p>
          <p className="mt-8 max-w-[32rem] border-l-[3px] border-orange pl-4 text-[15px] leading-relaxed text-body" data-id="element-278" data-mp="3cd772dc3yq81">
            <strong className="font-bold text-navy" data-id="element-279" data-mp="1r71t6tc9ca6q">School floor hockey</strong> — not field hockey, and not federation-rule competition. Activities are teacher-led and modified for beginners.
          </p>
        </div>

        <div className="lg:col-span-6 lg:col-start-7" data-id="element-280" data-mp="261oi21tj1on3">
          <h3 className="eyebrow text-body" data-id="element-281" data-mp="261g74fgystej">Bundle specification</h3>
          <dl className="mt-4 border-t-2 border-cyan" data-id="element-282" data-mp="18ezbrfrskpvf">
            {specRows.map(row => <div key={row.term} className="grid gap-1 border-b border-navy/10 py-4 sm:grid-cols-[150px_1fr] sm:gap-6 sm:py-5" data-id="element-283" data-mp="1dchlv9hjpb50">
                <dt className="text-[13px] font-semibold text-body sm:text-sm" data-id="element-284" data-mp="1iasw3lbr5nnr">{row.term}</dt>
                <dd className="text-[16px] font-bold leading-snug text-navy sm:text-[17px]" data-id="element-285" data-mp="1n4naqaci3cfz">{row.detail}</dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}